import React from 'react';
import './Myalert.css';
import { Button, Container, Alert, Row } from 'react-bootstrap';
import api from '../../seller-apis/api';
import servicesApi from '../../seller-apis/servicesApi';

function Myalert(props){

    //----------------------------- for mobile---------------------//


    return(
        <>
        <h5>{props.message}</h5>
 </>
    )



        //----------------------------- for mobile---------------------//
        // return (



        //     <div className="p-0  pr welcome-C bg-white">
    
        //         <Container>
        //             <Row>
                        
        //             <div className="col-5 text-center bg-theme card-div-alert" style={{backgroundImage: `url("/login-icon/11.png")`}}>
        //             <div className="card alert-card " >
        //             <img src="/success.png" alt="img"  className="w-25 check" />
        //             {/* <h5>{props.message}</h5> */}
        //             <p className="fs-13 f-700 theme-col">Vendor Registered.Our team will get back to you soon.</p>
        //                 </div>
        //                 </div>
    
        //                 <div className="col-7 text-center ">
        //                     <img src="/seller-logo.png" alt="img" className="w-50" /><br></br>
        //                     <img src="/login-icon/deliver.png" className="hand-bag mt-4" alt="img" />
    
        //                 </div>
        //             </Row>
        //         </Container>
        //     </div>
    
        // )


}

export default Myalert;